import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Avatar,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import {
  Menu as MenuIcon,
} from '@mui/icons-material';
import { useAuth } from '../../hooks/useAuth';
import { K, drawerWidth, topBarHeight } from './kobraLayoutTokens';

export const TopBar = ({ onMenuClick }) => {
  const { user, logout } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    logout();
    handleMenuClose();
  };

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        width: { md: `calc(100% - ${drawerWidth}px)` },
        ml: { md: `${drawerWidth}px` },
        minHeight: topBarHeight,
        borderBottom: `1px solid ${K.border}`,
        backgroundColor: '#fff',
        backgroundImage: 'none',
        boxShadow: '0 1px 4px rgba(18, 24, 38, 0.06)',
      }}
    >
      <Toolbar
        sx={{
          minHeight: topBarHeight,
          px: { xs: 1.5, sm: 2 },
          backgroundColor: '#fff',
        }}
      >
        <IconButton
          edge="start"
          onClick={onMenuClick}
          aria-label="abrir menú"
          sx={{
            mr: 1.5,
            display: { md: 'none' },
            color: K.navy,
            '&:hover': { bgcolor: alpha(K.blue, 0.06) },
          }}
        >
          <MenuIcon />
        </IconButton>
        <Typography
          variant="h6"
          noWrap
          component="div"
          sx={{
            flexGrow: 0,
            mr: 2,
            fontWeight: 800,
            letterSpacing: '-0.02em',
            color: K.navy,
            fontSize: { xs: '1rem', sm: '1.15rem' },
          }}
        >
          
        </Typography>
        <Box sx={{ flexGrow: 1 }} />
        <IconButton
          onClick={handleMenuOpen}
          size="small"
          sx={{
            p: 0.5,
            '&:hover': { bgcolor: alpha(K.blue, 0.06) },
          }}
        >
          <Avatar
            sx={{
              width: 36,
              height: 36,
              bgcolor: alpha(K.blue, 0.14),
              color: K.blue,
              fontWeight: 800,
              fontSize: '0.95rem',
            }}
          >
            {user?.name?.charAt(0) || 'U'}
          </Avatar>
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          slotProps={{
            paper: {
              sx: {
                mt: 1,
                borderRadius: 2,
                border: `1px solid ${K.border}`,
                boxShadow: '0 8px 24px rgba(18, 24, 38, 0.1)',
                minWidth: 180,
              },
            },
          }}
        >
          <MenuItem onClick={handleMenuClose} sx={{ color: K.navy, fontWeight: 600 }}
          >
            Perfil
          </MenuItem>
          <MenuItem onClick={handleMenuClose} sx={{ color: K.navy, fontWeight: 600 }}
          >
            Ajustes
          </MenuItem>
          <MenuItem onClick={handleLogout} sx={{ color: alpha(K.navy, 0.75), fontWeight: 600 }}>
            Cerrar sesión
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};
